import { render, staticRenderFns } from "./EditOrderItemModal.vue?vue&type=template&id=5564ba6c&scoped=true"
import script from "./EditOrderItemModal.vue?vue&type=script&lang=js"
export * from "./EditOrderItemModal.vue?vue&type=script&lang=js"
import style0 from "./EditOrderItemModal.vue?vue&type=style&index=0&id=5564ba6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5564ba6c",
  null
  
)

export default component.exports